import React from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";
import "./EngineeringJourney.css";

function EngineeringJourney() {
    const journey = [
        {
            year: "2018",
            title: "Secondary School (10th)",
            company: "Shradha Public Higher Sec. School • Katkut",
            desc: "Completed Secondary Education with a strong foundation in Mathematics and Science, developing analytical and problem-solving skills."
        },
        {
            year: "2020",
            title: "Higher Secondary (12th)",
            company: "New Golden Higher Sec. School • Indore",
            desc: "Completed Higher Secondary Education with a focus on Science, strengthening logical reasoning and preparing for engineering studies."
        },
        {
            year: "2020 – 2024",
            title: "B.Tech in Information Technology",
            company: "Swami Vivekananda College Of Engineering • Indore",
            desc: "Built a strong foundation in Data Structures, Algorithms, Object-Oriented Programming, DBMS, Operating Systems, Computer Networks, and Software Engineering. Developed multiple academic and personal projects using Java and web technologies."
        },
        {
          year: "Aug 2023 – Sep 2024",
          title: "Full Stack Java Developer",
          company: "Dollop Infotech Pvt. Ltd. • Indore",
          desc: "Developed enterprise web applications using Java, Spring Boot, Angular, React, MySQL, and REST APIs. Worked on backend development, frontend implementation, payment gateway integration, and database-driven solutions."
        },
        {
          year: "Sep 2024 – May 2026",
          title: "Java Developer",
          company: "Mwanzo Technologies Pvt. Ltd. • Ahmedabad",
          desc: "Contributed to large-scale enterprise applications with a focus on Java backend development, Spring MVC, Hibernate, SQL Server, API development, production support, and application maintenance."
        },
        {
          year: "May 2026 – Present",
          title: "Senior Java Developer",
          company: "Procure Tiger Pvt. Ltd. • Ahmedabad",
          desc: "Currently developing and maintaining ABC Procure, an enterprise e-Procurement platform. Working on backend architecture, Spring MVC, Hibernate, JSP, SQL Server, digital signature integration, workflow automation, production support, and security enhancements including CSP migration."
        }
      ];
  return (
    <Container fluid className="journey-section">
      <Particle />

      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Engineering Journey</strong>
        </h1>

        <div className="timeline">
          {journey.map((item, index) => (
            <div className="timeline-item" key={index}>
              <div className="timeline-dot"></div>

              <div className="timeline-content">
                <h5>{item.year}</h5>
                <h3>{item.title}</h3>
                <h6>{item.company}</h6>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </Container>
  );
}

export default EngineeringJourney;